import {useUserStore, useMarketplaceStore} from "@/console-new/stores";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import { getRouteInfo, isPlanAllowed, ordersPermissions, getAllRoutes } from "@/console-new/helpers/permissions";

export default {
	setup() {
		const userStore = useUserStore();
		const marketplaceStore = useMarketplaceStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		return {userStore, showNotification: notificationStore.showNotification, languageStore, marketplaceStore}
	},
	name: 'PermissionsSectionCheck',
	methods: {
		_isPlanAllowed(routeInfo) {
			return isPlanAllowed(routeInfo);
		},
		checkPermissions() {
			if(this.userStore.noBusinesses && !this.$route.path.includes('/lost') && !this.$route.path.includes('/add-business')) {
				this.$router.push('/lost');
				return true;
			}
			if(!this.userStore || !this.userStore.currPermissions || !this.userStore.currPermissions.length) {
				return false;
			}
			let permissions = this.userStore.currPermissions;

			let routeInfo = getRouteInfo(this.$route.path);
			if(routeInfo && routeInfo.permissions && routeInfo.permissions.length) {
				let allowed = routeInfo.permissions.some(v => permissions.includes(v));
				if (!allowed) {
					const safeRoute = this.findSafeRoute();
					if(safeRoute && safeRoute !== this.$route.path) {
						this.$router.push(safeRoute);
						return true;
					}
				}
			}
			return false;
		},
		checkPlan() {
			if(!this.userStore || !this.userStore.currBusiness) {
				return
			}

			let routeInfo = getRouteInfo(this.$route.path);
			let allowed = this._isPlanAllowed(routeInfo);

			if(!allowed) {
				const safeRoute = this.findSafeRoute();
				if(safeRoute && safeRoute !== this.$route.path) {
					this.$router.push(safeRoute);
				}
			}
		},
		findSafeRoute() {
			if(!this.userStore || !this.userStore.currPermissions || !this.userStore.currPermissions.length || !this.userStore.currBusiness) {
				return '/lost';
			}

			// Prioritize these paths in this order if the user has multiple permissions
			const pathsWithPriority = {
				'/ops/orders': ordersPermissions,
				'/config/menu': ['menu'],
				'/analytics/orders': ['analytics'],
				'/config/settings/general': ['admin'],
			}

			let permissions = this.userStore.currPermissions;

			// First, check priority paths in order
			for (const [path, requiredPermissions] of Object.entries(pathsWithPriority)) {
				// Check if user has any of the required permissions for this priority path
				let hasPermission = requiredPermissions.some(v => permissions.includes(v));
				if(hasPermission) {
					// Check if the route exists and validate plan access
					let routeInfo = getRouteInfo(path);
					if(routeInfo && this._isPlanAllowed(routeInfo)) {
						return path;
					}
				}
			}

			// If no priority path matches, fall back to finding any allowed path
			const allPaths = getAllRoutes();

			for (const path of allPaths) {
				let routeInfo = getRouteInfo(path);
				if(routeInfo && routeInfo.permissions && routeInfo.permissions.length) {
					let hasPermission = routeInfo.permissions.some(v => permissions.includes(v));
					if(hasPermission && this._isPlanAllowed(routeInfo)) {
						return path;
					}
				}
			}

			return '/lost';
		}
	},
	watch: {
		"$route": {
			handler: function(newRoute, oldRoute) {
				if(newRoute && (!oldRoute || newRoute.path !== oldRoute.path)) {
					let hasRedirected = this.checkPermissions();
					if(!hasRedirected) {
						this.checkPlan();
					}
					if (typeof CS_CONF !== "undefined" && window._uxa) {
						window._uxa.push([
							"trackPageview",
							window.location.pathname + window.location.hash.replace("#", "?__")
						]);
					}
				}
			},
			immediate: true
		},
		"userStore.currBusiness.permissions": {
			handler: function(newPerm, oldPerm) {
				if(newPerm && (!oldPerm || newPerm !== oldPerm)) {
					let hasRedirected = this.checkPermissions();
					if(!hasRedirected) {
						this.checkPlan();
					}
				}
			},
		},
		"userStore.currPlans": {
			handler: function(newPlans, oldPlans) {
				if(newPlans && (!oldPlans || newPlans !== oldPlans)) {
					let hasRedirected = this.checkPermissions();
					if(!hasRedirected) {
						this.checkPlan();
					}
				}
			},
		},
		"userStore.noBusinesses": {
			handler: function(newValue) {
				if(newValue) {
					let hasRedirected = this.checkPermissions();
					if(!hasRedirected) {
						this.checkPlan();
					}
				}
			},
		},
	},
}